import { useEffect, useState } from "react";
import ServiceMainComponent from "./components/layout";
import { servicesData } from "../../data/servicesData";
import { ServiceData } from "../../components/interfaces";
import { SEO } from "../../components/SEO";

export default function Service4() {
  const serviceName = "Acupuncture";
  const [otherServicesData, setOtherServicesData] = useState<ServiceData[]>([]);
  const [selectedService, setSelectedService] = useState<ServiceData>();

  useEffect(() => {
    const data = servicesData.filter(
      (service) => service.title !== serviceName
    );
    const servicePage = servicesData.find(
      (service) => service.title === serviceName
    );
    setSelectedService(servicePage);
    setOtherServicesData(data);
  }, []);
  return (
    <>
      <SEO
        title="Trusted Acupuncture Therapy in Canada | Last Minute Wellness"
        description="Discover top acupuncture therapists in Canada. Book same-day sessions instantly with Last Minute Wellness — simple, fast, stress-free."
        url="https://lastminutewellness.ca/service/acupuncture"
        image="https://lastminutewellness.ca/about-banner.png"
      />
      <ServiceMainComponent
        serviceTitle={serviceName}
        serviceImage={selectedService?.image}
        serviceDescData={selectedService?.desc}
        otherServicesData={otherServicesData}
      />
    </>
  );
}
